import { FC, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'hooks';
import { useRiveFileCache } from '../../RiveProvider';
import { SideBarMenuIcon } from '../SideBarIcon';
import './sideBarMenuItem.scss';
import { RootState } from 'store';
import { useSelector } from 'react-redux';

interface Props {
  title: string;
  icon?: string;
  selected?: boolean;
  active?: boolean;
  simple?: boolean;
  submenu?: boolean;
  withTooltip?: boolean;
}

export const SideBarMenuItem: FC<Props> = ({
  title,
  icon,
  selected,
  active,
  simple,
  withTooltip,
}) => {
  const getTranslate = useTranslation();
  const { riveFile, fileStatus } = useRiveFileCache();
  const [hovered, setHovered] = useState(false);
  const isMenuExpanded = useSelector(
    (state: RootState) => state.layoutConfiguration.isMenuExpanded
  );

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <div
      className={classNames('sidebar-menu-item', {
        'sidebar-menu-item_selected': selected,
        'sidebar-menu-item_active': active,
        'sidebar-menu-item_simple': simple,
      })}
      {...(withTooltip && {
        'data-place': 'right',
        'data-tip': !isMenuExpanded ? getTranslate(title) : undefined,
      })}
      onMouseEnter={icon ? handleMouseEnter : undefined}
      onMouseLeave={icon ? handleMouseLeave : undefined}>
      {icon && fileStatus === 'success' ? (
        <SideBarMenuIcon
          riveFile={riveFile!}
          icon={icon}
          hovered={hovered}
          selected={selected}
          active={active}
          isMenuExpanded={isMenuExpanded}
        />
      ) : null}
      <span className='sidebar-menu-item__text'>{getTranslate(title)}</span>
    </div>
  );
};
